import React, { lazy, Suspense } from 'react';

const LazySubscriptionComponent = lazy(() => import('./subscription.component'));

const SubscriptionLazyComponent = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => (
  <Suspense fallback={null}>
    <LazySubscriptionComponent {...props} />
  </Suspense>
);

export default SubscriptionLazyComponent;
